<div class="student-tab student-tab-projects">
    <div class="student-tab__header">
        <a href="{{ newProjectURL }}" class="student-tab__button" target="_self"
            >Create a Storyboard</a
        >
    </div>
    <ul id="creationsList" class="assignments no-list-style">
        <li *ngIf="populationComplete && creations.length === 0">
            <p>
                You have not created a project yet. <br />
                <a href="{{ newProjectURL }}">Create a Storyboard</a>
            </p>
        </li>
        <li>
            <div class="ring-loader-container" *ngIf="!populationComplete">
                <div class="ring-loader"></div>
            </div>
        </li>
        <ng-container *ngIf="populationComplete">
            <li
                *ngFor="let creation of displayedCreations; index as idx"
                class="assignment-tray-item"
                [ngClass]="{ closed: !isActive(creation.token) }"
            >
                <span class="assignment-show-info">
                    <i
                        (click)="toggleActive(creation.token)"
                        class="lm lm-dash-add"
                    ></i>
                    <i
                        (click)="toggleActive(creation.token)"
                        class="lm lm-dash-delete"
                    ></i>
                </span>
                <div class="assignment-content">
                    <i class="lm lm-assignment-icon lm-page"></i>
                    <span class="title">{{ creation.name }}</span>
                    <span class="date-created">
                        {{ creation.date_created | date: "MMMM d, yyyy" }}</span
                    >
                    <span class="assignment-url">
                        <a href="{{ creation.edit_url }}" target="_self">
                            <i class="lm lm-pencil"></i>
                        </a>
                    </span>
                </div>
                <div
                    *ngIf="isActive(creation.token)"
                    class="show-info clearfix"
                >
                    <span class="date-created mobile">
                        {{ creation.date_created | date: "MMMM d, yyyy" }}</span
                    >
                    <label class="storyboard-url">Storyboard URL</label>
                    <input
                        id="projects_share_link_{{ idx }}"
                        type="text"
                        value="{{ creation.share_url }}"
                        class="share-url"
                    />
                    <a
                        (click)="
                            copyLinkByElementId('projects_share_link_' + idx)
                        "
                        class="email-url"
                    >
                        <i class="lm lm-link"></i>
                        Copy Link
                    </a>
                </div>
            </li>
        </ng-container>
    </ul>
    <div
        class="show-more-results std-mgb"
        [ngClass]="{ closed: !shouldPaginate() }"
    >
        <span class="btn btn-show-more" (click)="showMore()"> Show More </span>
    </div>
</div>
